import { render, staticRenderFns } from "./PhotoModal.vue?vue&type=template&id=1a023361&scoped=true&"
import script from "./PhotoModal.vue?vue&type=script&lang=js&"
export * from "./PhotoModal.vue?vue&type=script&lang=js&"
import style0 from "./PhotoModal.vue?vue&type=style&index=0&id=1a023361&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a023361",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VDialog,VIcon})
